import { FETCH_CURRENT_USER, FETCH_CURRENT_USER_META, FETCH_CURRENT_USER_PERMISSIONS } from 'src/redux/actionTypes';

const initialState = {
  data: {},
  error: {
    data: null,
    meta: null,
    permissions: null,
  },
  formAuthenticityToken: null,
  hasFetched: {
    data: false,
    meta: false,
    permissions: false,
  },
  isLoading: {
    data: false,
    meta: false,
    permissions: false,
  },
  meta: {},
  passwordResetSent: false,
  permissions: [],
};

const getObjectWithChangedValue = (currentState, key, value) => ({
  ...currentState,
  [key]: value
});

export const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CURRENT_USER.INVOKE:
      return {
        ...state,
        isLoading: getObjectWithChangedValue(state.isLoading, 'data', true),
      };
    case FETCH_CURRENT_USER_META.INVOKE:
      return {
        ...state,
        isLoading: getObjectWithChangedValue(state.isLoading, 'meta', true),
      };
    case FETCH_CURRENT_USER_PERMISSIONS.INVOKE:
      return {
        ...state,
        isLoading: getObjectWithChangedValue(state.isLoading, 'permissions', true),
      };
    case FETCH_CURRENT_USER.SUCCESS: {
      const { user } = action.payload.data;

      return {
        ...state,
        data: user,
        error: getObjectWithChangedValue(state.error, 'data', null),
        hasFetched: getObjectWithChangedValue(state.hasFetched, 'data', true),
        isLoading: getObjectWithChangedValue(state.isLoading, 'data', false),
      };
    }
    case FETCH_CURRENT_USER_META.SUCCESS: {
      const { currentUserMeta } = action.payload.data;

      return {
        ...state,
        error: getObjectWithChangedValue(state.error, 'meta', null),
        hasFetched: getObjectWithChangedValue(state.hasFetched, 'meta', true),
        isLoading: getObjectWithChangedValue(state.isLoading, 'meta', false),
        meta: currentUserMeta,
      };
    }
    case FETCH_CURRENT_USER_PERMISSIONS.SUCCESS: {
      const { currentUserPermissions } = action.payload.data;

      return {
        ...state,
        error: getObjectWithChangedValue(state.error, 'permissions', null),
        hasFetched: getObjectWithChangedValue(state.hasFetched, 'permissions', true),
        isLoading: getObjectWithChangedValue(state.isLoading, 'permissions', false),
        permissions: currentUserPermissions,
      };
    }
    case FETCH_CURRENT_USER.ERROR:
      return {
        ...state,
        error: getObjectWithChangedValue(state.error, 'data', action.error),
        hasFetched: getObjectWithChangedValue(state.hasFetched, 'data', false),
        isLoading: getObjectWithChangedValue(state.isLoading, 'data', false),
      };
    case FETCH_CURRENT_USER_META.ERROR:
      return {
        ...state,
        error: getObjectWithChangedValue(state.error, 'meta', action.error),
        hasFetched: getObjectWithChangedValue(state.hasFetched, 'meta', false),
        isLoading: getObjectWithChangedValue(state.isLoading, 'meta', false),
      };
    case FETCH_CURRENT_USER_PERMISSIONS.ERROR:
      return {
        ...state,
        error: getObjectWithChangedValue(state.error, 'permissions', action.error),
        hasFetched: getObjectWithChangedValue(state.hasFetched, 'permissions', false),
        isLoading: getObjectWithChangedValue(state.isLoading, 'permissions', false),
      };
    default:
      return state;
  }
};
